module.exports = __webpack_public_path__ + "img/chat-incoming.2918c326.gif";